import { Modal } from '@mui/material';
import React from 'react';

interface Props {
  youtubeUrl: string;
  open: boolean;
  onClose: () => void;
}

export const TutorialVideoModal: React.FC<Props> = ({ youtubeUrl, open, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-tutorial-player"
      aria-describedby="modal-modal-tutorial-player"
      className="outline-none focus:outline-none"
      BackdropProps={{
        style: {
          background: 'rgba(0, 0, 0, 0.6)',
        },
      }}
    >
      <div className="absolute bg-white inset-1/2 -translate-x-1/2 -translate-y-1/2 w-[768px] h-[432px]">
        <iframe
          src={youtubeUrl}
          width="768px"
          height="432px"
          title="tutorial video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </Modal>
  );
};
